import { render, staticRenderFns } from "./ManageDatabase.vue?vue&type=template&id=7b98c84d&"
import script from "./ManageDatabase.js?vue&type=script&lang=js&"
export * from "./ManageDatabase.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports